export function LinkIsExternal(url: string) {
  const matchers = ['https://', 'http://', 'www.'];
  return matchers.some((matcher) => url.includes(matcher));
}

export function LinkIsVoucher(url: string) {
  return url.includes('qr.linktm.nl');
}

function LinkHasScheme(url: string) {
  return url.includes('//');
}

export function LinkAddScheme(url: string) {
  if (LinkHasScheme(url)) return url;
  return `//${url}`;
}

function LinkIsMixer(url: string) {
  return url.includes('mixer.thiememeulenhoff.nl');
}

export function LinkAddMixerData(url: string) {
  if (LinkIsMixer(url)) {
    return `${url + (url.includes('?') ? '&' : '?')}source=${window.location.href}`;
  }
  return url;
}
